import { createI18n } from 'vue-i18n'
import en from './locales/en.js'
import vi from './locales/vi.js'

// Create i18n instance
const i18n = createI18n({
  legacy: false, // use Composition API
  locale: localStorage.getItem('locale') || 'vi', // default locale
  fallbackLocale: 'vi',
  messages: {
    en,
    vi
  }
})
export default i18n
